export enum LocalStorageKeys {
  CUSTOM_HOMEPAGE = '/home.customHomepage/home',
}

export class LocalStorageHelper {
  static getItem<T>(key: LocalStorageKeys): T | null {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  static setItem<T>(key: LocalStorageKeys, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  static removeItem(key: LocalStorageKeys): void {
    localStorage.removeItem(key);
  }
}
